module.exports = __webpack_public_path__ + "static/img/limit_04.c38c2fd9.svg";